import { Model } from "@vuex-orm/core";
import shortid from "shortid";
import _ from "lodash";
import moment from "moment/moment";
import Product from "./Product";
import RequestOrderPayment from './RequestOrderPayment'
import RequestOrder from './RequestOrder'
import RequestOrderService from "./RequestOrderService"

export default class RequestOrderProduct extends Model {
  static entity = "requestOrderProducts";
  static fields() {
    return {
      id: this.attr("tmp/" + shortid.generate()),
      requestOrderId: this.attr(null),
      productId: this.attr(null),
      quantity: this.attr(1),
      unitPrice: this.string("0.00"),
      unitDiscount: this.string("0.00"),
      _isHit: this.attr(true),
      dateUpdated: this.attr(null),
      dateCreated: this.attr(null),
      dateRemoved: this.attr(null),
      product: this.attr(null)
    }
  }
    static beforeCreate(model) {
      model.unitPrice = parseFloat(model.unitPrice).toFixed(2)
      model.unitDiscount = parseFloat(model.unitDiscount).toFixed(2)
      
      const products = Product.query().all()
      const requestOrder = RequestOrder.query().find(model.requestOrderId)
      if(!requestOrder) return
      products.forEach(product => {
        if(product.isDefault && !model.productId && !Number.isInteger(requestOrder.id)) {
          model.productId = product.id
          model.unitPrice = parseFloat(product.price).toFixed(2)
          model.quantity = product.quantity
        }
      })
      model._updateRequestOrderPayment(model)
    }

    static beforeUpdate(model) {
      if(!model.quantity) {
        const product = Product.query().find(model.productId)
        if(product) 
          model.quantity = product.quantity
      }
    }

    static afterUpdate(model) {
      model.unitPrice = parseFloat(model.unitPrice).toFixed(2)
      model.unitDiscount = parseFloat(model.unitDiscount).toFixed(2)

      model._updateRequestOrderPayment(model)
    }

    static afterDelete(model) {
      model._updateRequestOrderPayment(model)
    }

    _updateRequestOrderPayment(model) {
        const requestOrderPayments = RequestOrderPayment.query().where('requestOrderId', model.requestOrderId).get()
        
        if(requestOrderPayments.length == 1) {
          const requestOrderProducts = RequestOrderProduct.query().where('requestOrderId', model.requestOrderId).get()
          const requestOrderServices = RequestOrderService.query().where('requestOrderId', model.requestOrderId).get()

          let totalPriceProducts = _.sumBy(requestOrderProducts, (requestOrderProduct) => {
            return (requestOrderProduct.unitPrice - requestOrderProduct.unitDiscount) * requestOrderProduct.quantity
          })

          let totalPriceServices = _.sumBy(requestOrderServices, (requestOrderServices) => {
            return (requestOrderServices.price - requestOrderServices.discount)
          })

          requestOrderPayments[0].$update({
            where: requestOrderPayments[0].id,
            data: {
              amount: parseFloat(totalPriceProducts + totalPriceServices).toFixed(2)
            }
          })
        }
    }
}
